import { render, staticRenderFns } from "./parentTable.vue?vue&type=template&id=09fe3925"
import script from "./parentTable.vue?vue&type=script&lang=js"
export * from "./parentTable.vue?vue&type=script&lang=js"
import style0 from "./parentTable.vue?vue&type=style&index=0&id=09fe3925&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports